import React from "react";
import cn from "classnames";
import GradientHeroTitle from "@ui/GradientHeroTitle";

const FloatingAd: React.FC<{
  title: string;
  children?: React.ReactNode;
  bgOn3XL?: boolean;
  variant?: "gradient" | "orange" | "white";
}> = ({ title = "", children, bgOn3XL = false, variant = "gradient" }) => {
  return (
    <div
      className={cn(
        "width-full flex flex-col items-center rounded-lg bg-accuRankerPurple-900 bg-right-bottom bg-bottom bg-no-repeat px-6 pt-6 pb-8",
        {
          "bg-[url(/backgrounds/wave.svg)]": !bgOn3XL,
          "3xl:bg-[url(/backgrounds/wave.svg)]": bgOn3XL,
        }
      )}
    >
      <h3
        className={cn("!mb-6 text-xl", {
          "text-accuRankerOrange-500": variant === "orange",
          "text-white": variant === "white",
        })}
      >
        {variant === "gradient" ? (
          <GradientHeroTitle>{title}</GradientHeroTitle>
        ) : (
          title
        )}
      </h3>
      {children}
    </div>
  );
};

export default FloatingAd;
